import * as React from "react";
import { Stack, Chip} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { FaRegEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: "#f1f1f5",
		color: "#000",
		fontSize: 14,
		fontWeight: 700,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 13,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: "white",
	},
	// // hide last border
	// "&:last-child td, &:last-child th": {
	// 	border: 0,
	// },
}));


export default function SmartLockLogsTable(props) {
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [showDetails, setShowDetails] = React.useState(false);
	const [activeID, setActiveID] = React.useState(null);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const renderStatusPills = (status) => {
		switch (status) {
			case 1:
				return <Chip variant="outlined" sx={{ backgroundColor: "lightorange", fontSize:"10px", fontWeight:700 }} label="INCOMPLETE" size="small" color="darkorange" />;
			case 2:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ebefff", fontSize:"10px", fontWeight:700 }} label="COMPLETE" size="small" color="primary" />;
			case 3:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffebeb", fontSize:"10px", fontWeight:700 }} label="INCOMPLETE" size="small" color="warning" />;
		}
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	function toSentenceCase(str) {
		if (!str) return str;
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	}

	const toggleDetailsView = (rowId) => {
		setActiveID(rowId);
		setShowDetails(!showDetails);
	};

	const handleAction = (event, rowid, details) => {
		props.handleClickPopOver(event, rowid);
	};

	return (
		<>
			<TableContainer component={Paper} sx={{ display: { xs: "none", md: "block" } }}>
				<Table sx={{ minWidth: 700 }} aria-label="customized table">
					<TableHead>
						<TableRow>
							<StyledTableCell>Password Name</StyledTableCell>
							<StyledTableCell align="left">Start Time</StyledTableCell>
							<StyledTableCell align="left">End Time</StyledTableCell>
							<StyledTableCell align="left">Status</StyledTableCell>
							<StyledTableCell align="left">Actions</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.isLoadingData ? (
							<StyledTableRow></StyledTableRow>
						) : (
							<>
								{(props.rows.length > 0 ? props.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
									<StyledTableRow key={row.id}>
										<StyledTableCell component="th" scope="row">{row.name}</StyledTableCell>
										<StyledTableCell align="left">{moment.utc(row.effective_time*1000).format('LLL')}</StyledTableCell>
										<StyledTableCell align="left">{moment.utc(row.invalid_time*1000).format('LLL')}</StyledTableCell>
										<StyledTableCell align="left">{renderStatusPills(row.phase)}</StyledTableCell>
										<StyledTableCell>
											<IconButton color="primary" size="small" aria-describedby={props.id} onClick={(e) => handleAction(e, row.id, row)}>
												<MoreHorizIcon />
											</IconButton>
										</StyledTableCell>
									</StyledTableRow>
								)):(
										<StyledTableRow>
											<StyledTableCell colSpan={6}> No Units Recorded </StyledTableCell>
										</StyledTableRow>
									))}
							</>
						)}
					</TableBody>
					<TableFooter>
						<TableRow></TableRow>
					</TableFooter>
				</Table>
				<TablePagination
					component="div"
					colSpan={12}
					count={props.rows.length}
					page={page}
					onPageChange={handleChangePage}
					rowsPerPage={rowsPerPage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					labelRowsPerPage="Rows per page" // Custom label for "Rows per page"
					sx={{
						// Styles for the TablePagination component itself
						"& .MuiInputBase-root.MuiInputBase-colorPrimary.MuiTablePagination-input.css-baf1rs-MuiInputBase-root-MuiTablePagination-select": {
							marginRight: "5px",
						},
						"& .MuiTablePagination-actions": {
							marginLeft: 0,
						},
						"& .MuiTablePagination-displayedRows": {
							fontSize: "1rem",
							margin: 0,
						},
						"& .MuiSelect-select.MuiInputBase-input": {
							fontSize: "1rem",
							marginTop: "10px",
						},
						"& .MuiTablePagination-selectLabel": {
							fontSize: "1rem",
						},
						"& .MuiInputBase-root-MuiTablePagination-select .MuiTablePagination-select": {
							marginTop: "4px",
						},
					}}
				/>
			</TableContainer>

			{/* MOBILE */}
			<TableContainer sx={{ display: { xs: "block", md: "none" } }} component={Paper}>
				<Table aria-label="customized table">
					<TableHead>
						<TableRow>
							<StyledTableCell>Unit Name</StyledTableCell>
							<StyledTableCell align="right">Actions</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.isLoadingData ? (
							<StyledTableRow></StyledTableRow>
						) : (
							<>
								{(rowsPerPage > 0 ? props.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : props.rows).map((row) => (
									<StyledTableRow key={row.id}>
										<StyledTableCell align="left">
											<span>{row.name}</span>
											<Stack spacing={1} style={{ fontSize: "16px", marginTop: "7px" }}>
												<span style={{ cursor: "pointer", display: "flex", alignItems: "center", fontSize: "15px" }} onClick={() => toggleDetailsView(row.id)}>
													See{" "}
													{activeID === row.id && showDetails ? (
														<>
															less <IoMdEyeOff style={{ marginLeft: "5px", marginTop: "1px" }} />
														</>
													) : (
														<>
															more <FaRegEye style={{ marginLeft: "5px", marginTop: "1px" }} />
														</>
													)}
												</span>
												{activeID === row.id && showDetails && (
													<>
														<span>
															{" "}
															<strong>Start Time:</strong>{moment.utc((row.effective_time)*1000).format('LLL')}
														</span>
														<span>
															<strong>End Time:</strong>{moment.utc(row.invalid_time*1000).format('LLL')}
														</span>
														<span>
															<strong>Status:</strong> {renderStatusPills(row.phase)}
														</span>
													</>
												)}
											</Stack>
										</StyledTableCell>
										<StyledTableCell align="center" sx={{ width: "1%" }}>
											<IconButton color="primary" size="small" aria-describedby={props.id} onClick={(e) => props.handleClickPopOver(e, row.id)}>
												<MoreHorizIcon />
											</IconButton>
										</StyledTableCell>
									</StyledTableRow>
								))}
							</>
						)}
					</TableBody>
					<TableFooter>
						<TableRow></TableRow>
					</TableFooter>
				</Table>
				<TablePagination
					component="div"
					count={props.rows.length}
					page={page}
					onPageChange={handleChangePage}
					rowsPerPage={rowsPerPage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					labelRowsPerPage="Rows" // Custom label for "Rows per page"
					sx={{
						// Styles for the TablePagination component itself
						"& .MuiInputBase-root.MuiInputBase-colorPrimary.MuiTablePagination-input.css-baf1rs-MuiInputBase-root-MuiTablePagination-select": {
							marginRight: "5px",
						},
						"& .MuiTablePagination-actions": {
							marginLeft: 0,
						},
						"& .MuiTablePagination-displayedRows": {
							fontSize: "0.95rem",
							margin: 0,
						},
						"& .MuiSelect-select.MuiInputBase-input": {
							fontSize: "0.95rem",
							marginTop: "5px",
						},
						"& .MuiTablePagination-selectLabel": {
							fontSize: "0.95rem",
						},
						"& .MuiInputBase-root-MuiTablePagination-select .MuiTablePagination-select": {
							marginTop: "4px",
						},
					}}
				/>
			</TableContainer>
		</>
	);
}
